import React, { forwardRef } from 'react';
import { useTranslation } from "react-i18next"
import styles from '../../styles/login.module.css';
import { Colors } from '../../themes/Colors';

const LoginInput = forwardRef((props, ref) => {
  const { t } = useTranslation()
  const {
    placeholder,
    type = 'string',
    value,
    onChange,
    style = {},
    className = '',
    rightElement,
    rightStyle = {},
    noPaddingRight = false,
    ...otherProps
  } = props;
  let rightElemStyle = {
    position: 'absolute',
    right: 'calc(var(--sp-lg)*1.6)',
    height: '100%',
    top: 0,
    paddingTop: 'calc(var(--sp-xxs)*2)',
    display: 'flex',
    alignItems: 'center'
  }

  const rightElementNoPadding = {
    position: 'absolute',
    right: '0',
    height: '100%',
    top: 0,
    paddingTop: 'calc(var(--sp-xxs)*2)',
    display: 'flex',
    alignItems: 'center'
  }

  return (
    <div style={{ position: 'relative' }}>
      <input
        {...props}
        placeholder={t(placeholder)}
        onChange={(e) => {
          onChange && onChange(e.target.value);
        }}
        value={value}
        type={type}
        className={styles.loginInput + ' ' + className}
        style={{
          ...style,
          color: Colors.black,
          fontSize: 'var(--fs-md2)'
        }}
        autoComplete="off"
        ref={ref}
        {...otherProps}
      />
      {rightElement ? (
        <div
          style={{...(noPaddingRight ? rightElementNoPadding: rightElemStyle),  ...rightStyle, }}
          >
          {rightElement}
        </div>
      ) : null}
    </div>
  );
});

export default LoginInput;
